import { adminBoundariesEndpoints } from '@ooh/contracts';
import type { EndpointDef, callEndpoint } from '@ooh/contracts';

// ─── Shared auth interface (mirrors transport-layers/POI query pattern) ───────

export interface WithCallWithAuth {
  callWithAuth: <TDef extends EndpointDef>(
    def: TDef,
    request: Parameters<typeof callEndpoint<TDef>>[1],
  ) => ReturnType<typeof callEndpoint<TDef>>;
}

// ─── Bbox params ──────────────────────────────────────────────────────────────

export interface AdministrativeAreaBboxParams {
  minLon: number;
  minLat: number;
  maxLon: number;
  maxLat: number;
}

// ─── Query factories ──────────────────────────────────────────────────────────

export const administrativeAreaQueries = {
  /**
   * Query factory for bbox-scoped administrative-area (e.g. Warsaw district) geometry.
   * Mirrors `transportLayerQueries.listByBbox`.
   *
   * The caller is responsible for:
   * - Passing a debounced bbox (to avoid over-fetching on pan/zoom)
   * - Setting `enabled: false` when the layer is off or the bbox is null
   */
  listByBbox: (auth: WithCallWithAuth, params: AdministrativeAreaBboxParams) => ({
    queryKey: [
      'administrative-areas',
      'list',
      params.minLon,
      params.minLat,
      params.maxLon,
      params.maxLat,
    ] as const,
    queryFn: () => auth.callWithAuth(adminBoundariesEndpoints.listGeoJson, params),
  }),
};
